import store from '@app/store';
import AuthService from '@auth/services/auth.service';
import AuthorizationService from '@auth/services/authorization.service';

const resetTenant = next => {
  store.commit('tenant/clearSelectedTenant');
  store.commit('centerSettings/clearCenterSettings');
  store.commit('tenant/clearTenantAlias');
  next();
};

// NOTE These routes are not used anymore. I keep them
// here to check some configuration if needed
const routes = [
  {
    path: '/register',
    name: 'auth-register',
    meta: { layout: 'bpc-userpages', publicRoute: true },
    component: () =>
      import(/* webpackChunkName: "auth-register" */ '../pages/register/register.vue'),
    beforeEnter: (to, from, next) => {
      // If we want to do some checks about tenant alias in the future
      // const alias = to.params.tenantAlias;
      resetTenant(next);
    },
  },
  {
    path: '/app-login',
    name: 'auth-login',
    meta: { layout: 'bpc-userpages', publicRoute: true },
    component: () => import(/* webpackChunkName: "auth-login" */ '../pages/login/login.vue'),
    beforeEnter: (to, from, next) => {
      // If we want to do some checks about tenant alias in the future
      // const alias = to.params.tenantAlias;
      resetTenant(next);
    },
  },
  {
    path: '/edit-password',
    name: 'auth-edit-password',
    meta: { layout: 'bpc-admin', withSidebar: true },
    component: () =>
      import(/* webpackChunkName: "admin-profiles" */ '../pages/edit-password/edit-password.vue'),
    beforeEnter: (to, from, next) => {
      // If we want to do some checks about tenant alias in the future
      // const alias = to.params.tenantAlias;
      resetTenant(next);
    },
  },
  {
    path: '/reset-password',
    name: 'auth-reset-password',
    meta: { layout: 'bpc-userpages', publicRoute: true },
    component: () =>
      import(/* webpackChunkName: "auth-login" */ '../pages/reset-password/reset-password.vue'),
    beforeEnter: (to, from, next) => {
      // If we want to do some checks about tenant alias in the future
      // const alias = to.params.tenantAlias;
      resetTenant(next);
    },
  },

  {
    path: '/confirm-account',
    name: 'auth-confirm-account',
    meta: { layout: 'bpc-userpages', publicRoute: true },
    component: () =>
      import(
        /* webpackChunkName: "auth-tenant-login" */ '../pages/confirm-account/confirm-account.vue'
      ),
    beforeEnter: (to, from, next) => {
      // If we want to do some checks about tenant alias in the future
      // const alias = to.params.tenantAlias;
      resetTenant(next);
    },
  },
];

export const TenantAuthRoutes = [
  {
    path: 'register',
    props: true,
    name: 'auth-tenant-register',
    meta: { layout: 'bpc-userpages', publicRoute: true },
    component: () =>
      import(/* webpackChunkName: "auth-tenant-register" */ '../pages/register/register.vue'),
    beforeEnter: (to, from, next) => {
      const $authService = new AuthService();
      if ($authService.isLoggedIn()) {
        const $authorizationService = new AuthorizationService();
        next($authorizationService.getRedirectToHomePage());
        return false;
      }
      next();
    },
  },
  {
    path: 'login',
    name: 'auth-tenant-login',
    props: true,
    meta: {
      layout: 'bpc-userpages',
      publicRoute: true,
      globalTenantRoute: true, // NOTE the routes with this param
      // set to true are accesibles the tenantalias = 'app'
    },
    component: () => import(/* webpackChunkName: "auth-login" */ '../pages/login/login.vue'),
    beforeEnter: (to, from, next) => {
      const $authService = new AuthService();
      if ($authService.isLoggedIn()) {
        const $authorizationService = new AuthorizationService();
        if (to.name !== 'auth-tenant-login') {
          next($authorizationService.getRedirectToHomePage());
          return false;
        }
      }
      next();
    },
  },
  {
    path: 'edit-password',
    name: 'auth-tenant-edit-password',
    props: true,
    meta: { layout: 'bpc-admin', withSidebar: true, globalTenantRoute: true },
    component: () =>
      import(
        /* webpackChunkName: "auth-tenant-edit-password" */ '../pages/edit-password/edit-password.vue'
      ),
  },
  {
    path: 'reset-password',
    name: 'auth-tenant-reset-password',
    props: true,
    meta: { layout: 'bpc-userpages', publicRoute: true, globalTenantRoute: true },
    component: () =>
      import(
        /* webpackChunkName: "auth-tenant-reset-password" */ '../pages/reset-password/reset-password.vue'
      ),
    beforeEnter: (to, from, next) => {
      next();
    },
  },

  {
    path: 'confirm-account',
    props: true,
    name: 'auth-tenant-confirm-account',
    meta: { layout: 'bpc-userpages', publicRoute: true },
    component: () =>
      import(
        /* webpackChunkName: "auth-tenant-confirm-account" */ '../pages/confirm-account/confirm-account.vue'
      ),
  },
];

export default routes;
